// extracted by mini-css-extract-plugin
export var attribution = "_cm-4";
export var authorName = "_cm-5";
export var quote = "_cm-3";
export var testimonial = "_cm-2";
export var trustedBy = "_cm-0";
export var trustedByLabel = "_cm-1";